import { render } from "./Productividad.vue?vue&type=template&id=5cf3ffe3"
import script from "./Productividad.vue?vue&type=script&lang=js"
export * from "./Productividad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__